import { render, staticRenderFns } from "./ColorectalScreeningDetails.vue?vue&type=template&id=c77deb16&scoped=true"
import script from "./ColorectalScreeningDetails.vue?vue&type=script&lang=js"
export * from "./ColorectalScreeningDetails.vue?vue&type=script&lang=js"
import style0 from "./ColorectalScreeningDetails.vue?vue&type=style&index=0&id=c77deb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77deb16",
  null
  
)

export default component.exports